// Format YYYY-MM-DD → DD/MM/YYYY (French)
export function formatDateFR(iso) {
  if (!iso) return "—";
  // Already in DD/MM/YYYY or other format → return as-is
  if (!/^\d{4}-\d{2}-\d{2}/.test(iso)) return iso;
  const [y, m, d] = iso.substring(0, 10).split("-");
  return `${d}/${m}/${y}`;
}

// Format ISO datetime → "DD/MM/YYYY HH:mm"
export function formatDateTimeFR(iso) {
  if (!iso) return "—";
  try {
    const date = new Date(iso);
    if (isNaN(date.getTime())) return iso;
    const d = String(date.getDate()).padStart(2, "0");
    const m = String(date.getMonth() + 1).padStart(2, "0");
    const y = date.getFullYear();
    const hh = String(date.getHours()).padStart(2, "0");
    const mm = String(date.getMinutes()).padStart(2, "0");
    return `${d}/${m}/${y} ${hh}:${mm}`;
  } catch {
    return iso;
  }
}
